export const departmentList = [
  {
    id: "1",
    value: "IT",
    label: "IT",
  },
  {
    id: "2",
    value: "LBM(LG)",
    label: "LBM(LG)",
  },
  // {
  //   id: "2",
  //   value: "LBM",
  //   label: "LBM",
  // },
  {
    id: "3",
    value: "LBD",
    label: "LBD",
  },
  {
    id: "4",
    value: "LBM(ID)",
    label: "LBM(ID)",
  },
  {
    id: "5",
    value: "IED",
    label: "IED",
  },
  {
    id: "6",
    value: "UP POWER",
    label: "UP POWER",
  },
  {
    id: "7",
    value: "UP WATER",
    label: "UP WATER",
  },
  {
    id: "8",
    value: "MOBLX",
    label: "MOBLX",
  },
];
